
export enum ActivityHistoryType {
    email,
    scheduledTask,
    pendingTask,
    task,
    sms,
    comment,
    whatsapp,
}